/**
 * Constants of the `plus_enabled` feature flag (TEC-744), kept free of React so the backoffice
 * flag registry (utils/feature-flags/feature-flag-registry.ts) can import them.
 */
export const PLUS_ENABLED_COOKIE = 'dev_enable_plus';
/** TODO(plus-integration): flip to true for the public launch (or move to a server-side switch). */
export const PLUS_ENABLED_DEFAULT = false;
export const PLUS_FLAG_KEY = 'plus_enabled';
